import { type JSX } from 'react';

import { type Down, type Left, type Right, type Up, type UpOrDown } from './arrow-types';
import { ArrowWrapper, StyledArrow } from './style';

type ArrowProps = {
  borderWidth?: number;
  // using Americanised "color" means the attribute isn't removed
  // from the DOM element, so use proper English here
  colour?: string;
  size?: number;
  x?: number;
  y?: number;
} & (UpOrDown | Up | Down | Right | Left);

export const Arrow = (props: ArrowProps): JSX.Element => {
  const { borderWidth, colour, size, x, y, ...direction } = props;

  return (
    // `data-cx-arrow-wrapper` is the stable hook consumers use to restyle the wrapper (which is
    // `position: absolute` by default) from their own styles — see matches-coupon's EventLink.
    // It replaces a `[class^='ArrowWrapper']` selector, which only resolved while the Linaria
    // `displayName` option happened to be on in that app's build (NGF-6728). Keep it on the element.
    <ArrowWrapper data-cx-arrow-wrapper x={x} y={y}>
      <StyledArrow arrowColor={colour} borderWidth={borderWidth} direction={direction} size={size} />
    </ArrowWrapper>
  );
};
